import { type ReactElement } from 'react'
import { NotReady } from '@components'
import { useGame } from '@front/model'
import { type WithGameId } from '@terros/common'
import { useRequiredParams } from '@util'
import { GameHeaderProvider } from '../competition_.$gameId/gameHeaderContext'
import { GameDataContext } from '../competition_.$gameId/useGameContext'
import { ActiveCompetitionPage } from './ActiveCompetitionPage'
import { createFileRoute } from '@tanstack/react-router'

function CompetitionView(): ReactElement {
  const { gameId } = useRequiredParams<WithGameId>()

  const { data, isLoading, error: getError, refetch, isFetching } = useGame({ gameId })

  if (isLoading || !data || getError) {
    return <NotReady data={data} error={getError} isLoading={isLoading} />
  }

  return (
    <GameDataContext.Provider value={{ data, refetch, isFetching }}>
      <GameHeaderProvider initialGame={data.game}>
        <ActiveCompetitionPage />
      </GameHeaderProvider>
    </GameDataContext.Provider>
  )
}

export const Route = createFileRoute('/competition_/$gameId_/view/')({
  component: CompetitionView,
})
